import { CarbonCredit } from 'src/app/shared/interfaces/carbon-credit';

export {
  CarbonCreditTypeBadge,
  displayValue,
  formatComitenteDocument,
  isExternalUrl,
  resolveCarbonCreditTypeBadge,
} from '../../register-confirmation/shared/register-confirmation-details.utils';

export function isAcxCredit(credit: CarbonCredit): boolean {
  const status = credit.statusCode?.toUpperCase() ?? '';
  if (status.includes('ACX') || status === 'SUBMITED_ACX' || status === 'IF_AG_APROV_B3') {
    return true;
  }

  const certifier = credit.certifierDescription?.toLowerCase() ?? '';
  return certifier.includes('verra') || certifier.includes('gold standard') || certifier.includes('goldstandard');
}
